import { InjectionToken } from '@angular/core';

export const DCSG_APP_NAME = new InjectionToken<string>('DCSG_APP_NAME');
